import { axios } from "~/plugins/request"

export function genSign(data) {
  return axios({
    method: 'get',
    url: '/im/api/genSign' + '?userName=' + data,
  })
}

export function speechRecognition(data) {
  return axios({
    method: 'get',
    url: '/im/api/speechRecognition',
    data: data
  })
}